import { render, staticRenderFns } from "./PatientBirthdayCard.vue?vue&type=template&id=49549520&scoped=true&"
import script from "./PatientBirthdayCard.vue?vue&type=script&lang=ts&"
export * from "./PatientBirthdayCard.vue?vue&type=script&lang=ts&"
import style0 from "./PatientBirthdayCard.vue?vue&type=style&index=0&id=49549520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49549520",
  null
  
)

export default component.exports